import { useQuery } from 'react-query';

import { getDevicesOnMap } from 'api/InteractiveMap/getDevicesOnMap';

export const useGetDevicesOnMap = (slug: string) => {
  const { data, refetch, isLoading, isRefetching } = useQuery(['devicesOnMap', slug], () => getDevicesOnMap(slug), {
    refetchOnWindowFocus: false,
    enabled: !!slug,
  });

  return { data, refetch, isLoading, isRefetching };
};
